import { FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { ClaimFormSubmitFieldValue } from '../../../types/claim-form-submit-field-value';
import { getClaimFormSubmitValue } from '../../../helpers/getClaimFormSubmitValue';

export const validationText = 'Skriv noget i feltet';

export type CompanyType = 'Forsikringsselskab' | 'Bank' | 'Andet';
export type FieldValueType = {
    label: string;
    value: string;
};

export const radioOptions = [
    {
        value: 'Forsikringsselskab',
        caption: 'Forsikringsselskab',
        helpText: ''
    },
    {
        value: 'Bank',
        caption: 'Bank',
        helpText: ''
    },
    {
        value: 'Andet',
        caption: 'Andet',
        helpText: ''
    }
];

export const contentElementId: Record<CompanyType, Record<string, string>> = {
    Forsikringsselskab: {
        companyNameId: 'forsikringsselskabetsnavn',
        policyNumberId: 'policeForsikringsnummer'
    },
    Bank: {
        bankNameId: 'bankensnavn',
        nameOnCardId: 'hvilketnavnstrderpkortet',
        cardNumberId: 'kortnummer'
    },
    Andet: {}
};

export const isContentValid = (selectedOption: CompanyType, formValues: FormValues) => {
    if (selectedOption === 'Andet') {
        return true;
    } else {
        const contentElements = contentElementId[selectedOption];
        if (Object.values(contentElements).some((id) => formValues[id] === undefined)) {
            return false;
        } else {
            return Object.values(contentElements).every((id) => formValues[id].value !== '');
        }
    }
};

export const getContentSubmitValue = (selectedOption: CompanyType, formValues: FormValues) => {
    const contentSubmitValue: ClaimFormSubmitFieldValue[] = [];
    const contentElements = contentElementId[selectedOption];

    Object.values(contentElements).forEach((elementId) => {
        const contentValue = formValues[elementId];
        const { label, value } = contentValue;
        const valueId = { string: value };

        const component = elementId === 'kortnummer' ? 'numberfield' : 'textfield';

        const submitValue = getClaimFormSubmitValue(component, elementId, label, value, valueId);

        contentSubmitValue.push(submitValue);
    });
    return contentSubmitValue;
};
